import { render, staticRenderFns } from "./activityStaff.vue?vue&type=template&id=50fde109&scoped=true"
import script from "./activityStaff.vue?vue&type=script&lang=js"
export * from "./activityStaff.vue?vue&type=script&lang=js"
import style0 from "./activityStaff.vue?vue&type=style&index=0&id=50fde109&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50fde109",
  null
  
)

export default component.exports